module.exports = __webpack_public_path__ + "static/media/clock.803f5805.svg";